import './index.styl';

import template from './index.jst';
import FieldCoreView from '../Core';

export class TeamFieldPitch extends FieldCoreView {
	get template() {
		return template;
	}
}

export default TeamFieldPitch;